import { render, staticRenderFns } from "./BoxMultiEnderecos.vue?vue&type=template&id=46d0bb5a&scoped=true&"
import script from "./BoxMultiEnderecos.vue?vue&type=script&lang=js&"
export * from "./BoxMultiEnderecos.vue?vue&type=script&lang=js&"
import style0 from "./BoxMultiEnderecos.vue?vue&type=style&index=0&id=46d0bb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d0bb5a",
  null
  
)

export default component.exports